var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-configured-payout py-6 px-2"},[_vm._v(" "+_vm._s(_vm.$t("You can set up your payout information later."))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }